import { Component } from '@angular/core';

@Component({
  selector: 'devapp-app',
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
})
export class AppComponent {}
